<div class="given-filters">
  <div class="filter-field">
    <div class="easy-form">
      <mat-form-field>
        <mat-label>{{
          "VIP_DISCOUNTS.GIVEN.FILTER.COMPANY" | translate
        }}</mat-label>
        <mat-select
          [formControl]="companyFilterControl"
          [multiple]="true"
          panelClass="vip-company-filter-panel"
          (openedChange)="onCompanyPanelToggle($event)"
        >
          <mat-select-trigger>
            {{ companyFilterControl.value.length }}
            {{ "VIP_DISCOUNTS.GIVEN.FILTER.COMPANY_SELECTED" | translate }}
          </mat-select-trigger>

          <div class="select-search" (click)="$event.stopPropagation()">
            <input
              class="select-search-input"
              [formControl]="companySearchControl"
              (keydown)="$event.stopPropagation()"
              [placeholder]="
                'VIP_DISCOUNTS.GIVEN.FILTER.COMPANY_SEARCH' | translate
              "
            />
          </div>

          <ng-container *ngIf="(filteredCompanies$ | async) ?? [] as companies">
            <mat-option
              *ngFor="let company of companies"
              [value]="company.merchantId"
            >
              {{ company.companyName }}
            </mat-option>

            <div class="select-no-results" *ngIf="companies.length === 0">
              {{ "VIP_DISCOUNTS.GIVEN.FILTER.NO_COMPANY" | translate }}
            </div>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>

    <ng-container
      *ngIf="(selectedCompanies$ | async) ?? [] as selectedCompanies"
    >
      <mat-chip-listbox
        class="selected-companies"
        *ngIf="selectedCompanies.length"
      >
        <mat-chip
          *ngFor="let company of selectedCompanies"
          (removed)="removeCompany(company.merchantId ?? '')"
        >
          {{ company.companyName }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-listbox>
    </ng-container>
  </div>

  <div class="filter-field">
    <div class="easy-form">
      <mat-form-field>
        <mat-label>{{
          "VIP_DISCOUNTS.GIVEN.FILTER.PRODUCT_NAME" | translate
        }}</mat-label>
        <input
          matInput
          [formControl]="productNameControl"
          [placeholder]="
            'VIP_DISCOUNTS.GIVEN.FILTER.PRODUCT_NAME_PLACEHOLDER' | translate
          "
        />
      </mat-form-field>
    </div>
  </div>
</div>

<button
  type="button"
  mat-stroked-button
  color="primary"
  class="delete-btn"
  [disabled]="(isAllGivenMerchantsSelected$ | async) === 'NOT_CHECKED'"
  (click)="deleteSelectedItems()"
>
  {{ "VIP_DISCOUNTS.GIVEN.DELETE_SELECTED_ITEMS" | translate }}
</button>

<app-vip-discounts-given-table
  *ngFor="let discount of discountsGiven$ | async; let i = index"
  [discount]="discount"
  [tableIndex]="i"
  [showCaptionRow]="i === 0"
></app-vip-discounts-given-table>

<p
  class="empty-message"
  *ngIf="
    (discountsGivenLoading$ | async) === false && (totalElements$ | async) === 0
  "
>
  {{ "VIP_DISCOUNTS.GIVEN.EMPTY" | translate }}
</p>

<mat-paginator
  [length]="(totalElements$ | async) ?? 0"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [pageSizeOptions]="pageSizeOptions"
  (page)="onPage($event)"
  showFirstLastButtons
></mat-paginator>
